import '../styles/Contact.css';

function Portfolio() {
  const projects = [
    {
      title: 'Manufacturing process optimization',
      category: 'Lean Consulting',
      impact: 'Cost Reduction',
      description: 'Eliminated inefficiencies in production processes, resulting in significant cost savings and improved throughput.',
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=600&h=350&fit=crop'
    },
    {
      title: 'Financial services transformation',
      category: 'Business Transformation',
      impact: 'Faster Processing',
      description: 'Redesigned core business processes to improve customer experience and operational efficiency.',
      image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=350&fit=crop'
    },
    {
      title: 'Supply chain excellence',
      category: 'Process Improvement',
      impact: 'Inventory Reduction',
      description: 'Streamlined supply chain operations through systematic process improvement and lean methodology.',
      image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600&h=350&fit=crop'
    },
    {
      title: 'Operational readiness program',
      category: 'Operational Excellence',
      impact: 'Defect Reduction',
      description: 'Implemented Six Sigma methodologies to achieve exceptional quality improvements across all operations.',
      image: 'https://images.unsplash.com/photo-1565106430482-8f6e74349ca1?w=600&h=350&fit=crop'
    },
    {
      title: 'Healthcare process innovation',
      category: 'Consultancy & Coaching',
      impact: 'Patient Throughput Increase',
      description: 'Optimized clinical and administrative processes to improve patient care and staff productivity.',
      image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=600&h=350&fit=crop'
    },
    {
      title: 'Digital transformation initiative',
      category: 'Business Transformation',
      impact: 'Time Savings',
      description: 'Led organizational change to implement new digital tools and processes across all departments.',
      image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=350&fit=crop'
    }
  ];

  return (
    <div className="portfolio">
      {/* Header */}
      <section className="portfolio-header">
        <div className="portfolio-header-overlay"></div>
        <div className="portfolio-header-content">
          <h1>Our Portfolio</h1>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="portfolio-content">
        <div className="portfolio-container">
          <div className="projects-grid">
            {projects.map((project, index) => (
              <div key={index} className="project-card">
                <div className="project-image-wrapper">
                  <img src={project.image} alt={project.title} className="project-image" />
                  <span className="project-category">{project.category}</span>
                </div>
                <div className="project-body">
                  <div className="project-header">
                    <h3 className="project-title">{project.title}</h3>
                  </div>
                  <p className="project-description">{project.description}</p>
                  <div className="project-footer">
                    <span className="project-impact">{project.impact}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="portfolio-cta">
        <h2>Ready to Transform Your Organization?</h2>
        <p>Let's discuss how we can help you achieve similar results.</p>
        <a href="/contact" className="cta-button">Book a Consultation</a>
      </section>
    </div>
  );
}

export default Portfolio;
